import styled from 'styled-components';
import { getSpacingToken, getTransition } from '@optimus-web/core';
import { CardTypeImageStyledProps } from './types';

const CARD_DISABLED_OPACITY = 0.2;
const CARD_ENABLED_OPACITY = 1;
const CARD_HEIGHT = '22px';
const CARD_WIDTH = '36px';

export const CardTypeImageStyled = styled.img.attrs<CardTypeImageStyledProps, { role: string }>({
    role: 'presentation',
})`
    height: ${CARD_HEIGHT};
    width: ${CARD_WIDTH};
    vertical-align: bottom;
    margin-right: ${getSpacingToken('50')}px;
    margin-top: ${getSpacingToken('50')}px;
    transition: ${getTransition('opacity')};
    opacity: ${(props: CardTypeImageStyledProps) => (props.enabled ? CARD_ENABLED_OPACITY : CARD_DISABLED_OPACITY)};
`;
